import * as CommonUx from '@abb/common-ux';
import * as Oidc from 'oidc-client';
import * as React from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router-dom';

import { IAuthenticationProps, IConnectedComponent } from 'reducers';
import { Settings } from '../Settings';

export class LogoutComponent extends React.Component<IConnectedComponent & IAuthenticationProps & RouteComponentProps<any>, any> {
  async componentWillMount() {
    const manager = new Oidc.UserManager(Settings);  
    const user = await manager.getUser();

    if (user !== null && user !== undefined) {
      if (this.props.location.search.indexOf('?success') >= 0) {
        manager.signoutRedirectCallback().then((u) => this.props.logout(u));
      } else {
        manager.signoutRedirect();
      }

      manager.clearStaleState();
    } else {    
      this.props.logout(user);
      this.props.history.push('/');
    }
  }
  render() {
    return (
      <div>
        <p>You have logged out.</p>
      </div>
    );
  }
}

export default withRouter(connect(null, mapDispatchToProps)(LogoutComponent));

function mapDispatchToProps(dispatch: any, ownProps: any) {
  return {
    logout(user: any) {
      dispatch({ type: 'USER_LOGIN', loggedInUser: null });
    },
  };
}
